package com.veldekar.components.logs

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*
import com.veldekar.components.widgets.LocalizedSessionDate
import com.veldekar.components.widgets.InvertibleImage

@Composable
fun Log_2026_02_14_Day_3() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Tuesday tells the other heroes and Leah about the dragon’s wings in the night. Zen is also the cook. Leah asks Sparrow to teach Caper and Dirk sailing and knots.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Hanon offers to teach Bigglesworth some sea fishing techniques. Bigglesworth is a fast learner (at fishing) and catches a 90-pound tuna. Zen cooks it up, and everyone enjoys it.")
    }
}
